import moment from 'moment';
import { exportCSVFile } from '../utils';

const getExportDataSolicitudes = async (solicitudes) => {
  const itemsFormatted = [];
  const encabezado = {
    codigo_companhia: 'codigo_companhia',
    codigo_seccion: 'codigo_seccion',
    tipo_poliza: 'tipo_poliza',
    ruc: 'ruc',
    cedula: 'cedula',
    nombre_asegurado: 'nombre_asegurado',
    direccion: 'direccion',
    telefono: 'telefono',
    celular: 'celular',
    fecha_nacimiento: 'fecha_nacimiento',
    documento_vendedor: 'documento_vendedor',
    moneda: 'moneda',
    premio: 'premio',
    forma_cobro: 'forma_cobro',
    cant_cuotas: 'cant_cuotas',
    monto_cuotas: 'monto_cuotas',
    codigo_companhia_anterior: 'codigo_companhia_anterior',
    codigo_seccion_anterior: 'codigo_seccion_anterior',
    poliza_anterior: 'poliza_anterior',
    endoso_anterior: 'endoso_anterior',
    riesgo: 'riesgo',
    cuenta_bantotal: 'cuenta_bantotal',
    tipo_cta_tarjeta: 'tipo_cta_tarjeta',
    nro_cta_tarjeta: 'nro_cta_tarjeta',
    vto_tarjeta: 'vto_tarjeta',
    documento_oficial_cta: 'documento_oficial_cta',
    email_asegurado: 'email_asegurado',
    inicio_vigencia: 'inicio_vigencia',
    codigo_grupo: 'codigo_grupo',
    nombre_grupo: 'nombre_grupo'
  };
  solicitudes.forEach((item) => {
    itemsFormatted.push({
      codigo_companhia: ' ', // a definir por tito
      codigo_seccion: ' ', // a definir por tito
      tipo_poliza: 1, // por ahora siempre 1 (1 nueva, 2 renovacion)
      ruc: item.cotizacion?.persona?.ruc || ' ',
      cedula: item.cotizacion?.persona?.cedula || ' ',
      nombre_asegurado:
        item.cotizacion?.persona?.nombres?.replace(/,/g, ' ') || ' ',
      direccion: item.cotizacion?.persona?.domicilio
        ? item.cotizacion.persona.domicilio.replace(/,/g, '.')
        : ' ',
      telefono: ' ', // no tenemos
      celular: item.cotizacion?.persona?.celular || ' ',
      fecha_nacimiento: item.cotizacion?.persona?.fecha_nacimiento || ' ',
      documento_vendedor: ' ', // no tenemos
      moneda: 1, // por ahora siempre 1 (1 gs, 2 usd)
      premio: ' ', // a definir por tito
      forma_cobro: getMetodoPago(item),
      // cant_cuotas: getCantidadCuotas(item),
      // cant_cuotas: 0,
      cant_cuotas: item.json_plan?.numeroCuotas || 0,
      // monto_cuotas: getMontoCuotas(item),
      monto_cuotas: 0,
      codigo_companhia_anterior: ' ', // no tenemos
      codigo_seccion_anterior: ' ', // no tenemos
      poliza_anterior: ' ', // no tenemos
      endoso_anterior: ' ', // no tenemos
      riesgo: ' ', // a definir por tito
      cuenta_bantotal: ' ', // a definir por tito
      tipo_cta_tarjeta: ' ', // no guardamos
      nro_cta_tarjeta: ' ', // no guardamos
      vto_tarjeta: ' ', // no guardamos
      documento_oficial_cta: ' ', // a definir por tito
      email_asegurado: item.cotizacion?.persona?.correo || ' ',
      inicio_vigencia: moment(item.fecha).format('DD/MM/YYYY'), // fecha de la solicitud
      codigo_grupo: ' ', // a definir por tito
      nombre_grupo: ' ' // a definir por tito
    });
  });
  // call the exportCSVFile() function to process the JSON and trigger the download
  exportCSVFile(encabezado, itemsFormatted, 'solicitudes');
};

const getMetodoPago = (item) => {
  const { metodoPago } = item;
  switch (metodoPago.codigo) {
    case 'tarjeta':
      return 'T';
    case 'cadebito':
      return 'D';
    default:
      // NOTE: pago express y pago movil entrarian por este
      return 'C';
  }
};

export default getExportDataSolicitudes;
